'use strict';

var React = require('react');
var ClassNames = require('classnames');
var ApplicationConstants = require('../../constants/ApplicationConstants.js');
var InlineError = require('./InlineError.jsx');
var InlineMessage = require('./InlineMessage.jsx');
var ApplicationConstants = require('../../constants/ApplicationConstants');
var InlineInfoMessage = require('./InlineInfoMessage.jsx');
var InlineInfoButton = require('./InlineInfoButton.jsx');
var _ = require('lodash');
var Spinner = require('./Spinner.jsx');

function radioInputData(props, propName) {
    if (props[propName]) {
        var data = props[propName];
        if (!data || data.length < 0) {
            return new Error('data prop is required and must be array of the following object {id, name, isHidden');
        }

        for (var obj in data) {
            if (!(data[obj].hasOwnProperty('id') && data[obj].hasOwnProperty('name') && data[obj].hasOwnProperty('isHidden'))) {
                return new Error('one or more data does not have the following properties {id, name, isHidden}');
            }
        }
    }
    // assume all ok
    return null;
}

var RadioInput = React.createClass({
    getInitialState: function () {
        return {
            showHiddenItem: false,
            hideHelpText: true,
            focusOn: undefined
        };
    },
    getDefaultProps: function () {
        return {
            isValid: true,
            isHidden: false,
            hideBottomText: false,
            mandatory: true,
            moreButtonText: '+ More',
            helpText: '',
            disabled: false
        };
    },
    propTypes: {
        id: React.PropTypes.string.isRequired,
        label: React.PropTypes.string,
        labelRightText: React.PropTypes.string,
        note: React.PropTypes.node,
        data: radioInputData,
        onChange: React.PropTypes.func,
        rightText: React.PropTypes.string,
        isHidden: React.PropTypes.bool,
        errorList: React.PropTypes.array,
        bottomText: React.PropTypes.string,
        mandatory: React.PropTypes.bool,
        hideBottomText: React.PropTypes.bool,
        moreButtonText: React.PropTypes.string,
        disabled: React.PropTypes.bool,
        contextualMessage: React.PropTypes.string,
        model: React.PropTypes.string,
        customClass: React.PropTypes.string,
        helpText: React.PropTypes.string
    },

    focusOnFirstHiddenItem: function(){
        var item = _.find(this.props.data, {isHidden: true});
        this.setState({ showHiddenItem: true, focusOn: item.id });
    },

    showHiddenItemsOnKeyPress: function(event){
        if (event.keyCode === 32){
            this.focusOnFirstHiddenItem();
            event.stopPropagation();
            event.preventDefault();
        }
    },

    toggleShowHideHelpText: function() {
        this.setState({
            hideHelpText: !this.state.hideHelpText
        });
    },

    inlineErrorMessage: function () {
        var errorMessage = null;
        //if errorList is passed, use it otherwise use errorHeading / errorText 
        if(this.props.errorList) {
            var errorOfTheField = _.filter(this.props.errorList, { id: this.props.id });
            if (errorOfTheField.length > 0 && errorOfTheField[0]) {
                errorMessage = (<InlineMessage key={this.props.key} 
                                               id={'inline-message-' + this.props.id} 
                                               isHidden={!errorOfTheField[0].message} 
                                               type={errorOfTheField[0].type || ApplicationConstants.messageTypes.error}
                                               message={errorOfTheField[0].message}
                                               errorClickHandler={this.props.errorClickHandler} />);
            } 
        } else if (this.props.errorHeading || this.props.errorMessage){
            errorMessage =  <InlineError className="alert alert-warning" isHideError={this.props.errorList || this.props.isValid} header={this.props.errorHeading || 'Invalid ' + this.props.label} message={this.props.errorMessage} />;
        }
        return errorMessage; 
    },

    componentWillReceiveProps: function (nextProps) {
        if (this.props.data !== nextProps.data){
            this.setState({ showHiddenItem: false });  //when getting the new list of data,  reset state to original i.e. let it shows More button if applicable
        }
        // This is needed to make sure, when the component has got prop changed (note that prop changed is not triggered when component 
        // is initialized), the logic of show selected item will be called 
        if (this.props.value !== nextProps.value) {
            this.showHiddenSelectedItem(nextProps.data, nextProps.value);
        }
    }, 

    handleOnChange: function(event){
      if(this.props.onChange){
        //Instead of passing the id of input element, component id will be passed for validation message
        this.props.onChange({target: {id: this.props.id, value: event.target.value, model: this.props.model}});
      }
    },

    handleOnBlur: function(event) {
        if(this.props.onBlur){
        //Instead of passing the id of input element, component id will be passed for validation message
        this.props.onBlur({target: {id: this.props.id, value: event.target.value, model: this.props.model}});
      }
    },

    handleKeySelection: function(event){
        //keyboard keys: space bar
        if (!event.keyCode) return;
        if (event.keyCode === 32 || (event.keyCode >= 37 && event.keyCode <= 40)) {
            const elemntId = _.get(event, 'currentTarget.htmlFor', null);
            const element = elemntId ? document.getElementById(elemntId) : null;
            if (element) {
                const valueItem = element.attributes.getNamedItem('value');
                if (valueItem) {
                    const value = valueItem.value;
                    let index = _.findIndex(this.props.data, function (o) { return o.id == value });
                    const dataLength = this.props.data.length;
                    if (index !== -1 && dataLength > 1) {
                        // select the previous/next option only if current index can be found

                        //keyboard keys: left arrow, up arrow
                        if (event.keyCode === 37 || event.keyCode === 38) {
                            index = (index === 0) ? dataLength - 1 : --index;
                        }
                            //keyboard keys: right arrow and down arrow
                        else if (event.keyCode === 39 || event.keyCode === 40) {
                            index = (index === dataLength - 1) ? 0 : ++index;
                        }

                        const toBeSelectedItem = this.props.data[index];
                        if (toBeSelectedItem && !toBeSelectedItem.isDisabled && !toBeSelectedItem.isHidden) {
                            //call onChange to set change the value
                            this.handleOnChange({ target: { value: toBeSelectedItem.id } });
                            this.setState({ focusOn: toBeSelectedItem.id });
                        }
                    }
                }
            }
            event.stopPropagation();
            event.preventDefault();
        }
    },

    handleMouseDown: function (event) {
        const isIE = false || !!document.documentMode;
        if (!isIE) {
            event.preventDefault();
            event.stopPropagation();
        }
    },

    showHiddenSelectedItem(data, value) {
        if (data && value) {
            var selectedObject = _.find(data,
                function(item) {
                    return item.id == value;
                });

            if (selectedObject && selectedObject.isHidden) {
                this.setState({ showHiddenItem: true });
            }
        }
    },

    componentDidUpdate: function () {
        if (this.state.focusOn){
            //set focus to the selected element
            var id = 'label-' + this.props.id + '-' + this.state.focusOn;
            this.refs[id].focus();
            this.setState({focusOn: undefined});
        }
    },


    componentDidMount: function () {
        // This is needed to make sure when the component was initialized, the logic of show selected item will be called 
        this.showHiddenSelectedItem(this.props.data, this.props.value);
    },

    render: function () {
        var radioWithLabel = function (item) {
            var id = this.props.id + '-' + item.id;
            var divKey = 'div-' + id;
            var inputKey = 'input-' + id;
            var labelKey = 'label-' + id;
            var checked = (this.props.value == item.id);
            return <div className={ClassNames('div-with-radio-label', { hidden: !this.state.showHiddenItem && item.isHidden })} key={divKey}>
                            <label ref={labelKey} htmlFor={inputKey} onBlur={this.handleOnBlur} tabIndex="0" key={labelKey} className={ClassNames({'btn-cfs': checked})} onKeyDown={item.id !== '+more' ? this.handleKeySelection  : this.showHiddenItemsOnKeyPress} onMouseDown={this.handleMouseDown} disabled={this.props.disabled || item.isDisabled || false }>
                                <input key={inputKey} tabIndex="-1" id={inputKey} name={this.props.id} type="radio" value={item.id} checked={checked} onChange={item.id !== '+more' ? this.handleOnChange : this.focusOnFirstHiddenItem} onBlur={this.handleOnBlur} disabled={this.props.disabled || item.isDisabled || false} />
                                {item.name}
                            </label>
            </div> }.bind(this);

        var shouldShowMoreButton = _.filter(this.props.data, function (o) { return o.isHidden}).length > 0;
        var moreButton = null;
        if (shouldShowMoreButton && !this.state.showHiddenItem) {
            moreButton = radioWithLabel({ id: '+more', name: this.props.moreButtonText, isHidden: false });
        }
        var note = <p>{this.props.note}</p>;
        var rightText = !this.props.mandatory || this.props.rightText ? <span className="form-inline-field optional optional-right-text"> {this.props.rightText || 'optional '}</span> : null;
        var bottomText = this.props.bottomText ? <div className={ClassNames('form-sub-section', { hidden: this.props.hideBottomText }) } dangerouslySetInnerHTML={{__html:this.props.bottomText}} /> : null; 
        
        var label = this.props.label ?
                    <div className="form-label-section">
                        <label htmlFor={this.props.id }>
                            {this.props.label}
                            <InlineInfoButton helpText={this.props.helpText} isHidden={this.state.hideHelpText} toggleShowHideHelpText={this.toggleShowHideHelpText} />
                            {this.props.labelRightText}
                        </label>
                    </div> : null;
        var hideSpinner = this.props.data && this.props.data.length > 0;
        return (
            <div id={this.props.id} className={ClassNames('form-section', this.props.customClass, { hidden: this.props.isHidden })}>
                {label}
                <InlineInfoMessage isHidden={this.state.hideHelpText} message={this.props.helpText} />
                {hideSpinner ?
                (<div className="form-select">
                    {note}{this.props.data.map(function (item, index) {
                        return radioWithLabel(item, index);
                    })}{moreButton} {rightText}
                </div>) : (<Spinner customClass="left-spinner"/>)}
                {bottomText}
                { //don't display contextual message when there is error message
                    this.inlineErrorMessage() || 
                    <InlineMessage key={this.props.key}
                                   id={'contextual-message-' + this.props.id}
                                   type={ApplicationConstants.messageTypes.info}
                                   message={this.props.contextualMessage}
                                   isHidden={!this.props.contextualMessage} /> }
            </div>
        );
    }
});

module.exports = RadioInput;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/RadioInput.jsx